import React from 'react';
import { MS_TOPICS } from '../../messages/mockData';
import type { MsTopicKey } from '../../messages/types';

/**
 * Current-topic chip shown on an inbox row (replaces the old free-text tag dots).
 * Topics are the only SMS classification in V1 (spec D8/D9).
 */
export function MessagesTopicChip({ topic, sm }: { topic?: MsTopicKey | null; sm?: boolean }) {
  if (!topic) return null;
  const meta = MS_TOPICS[topic];
  if (!meta) return null;

  return (
    <span
      className="inline-flex items-center gap-1 rounded-[var(--r-sm)] font-semibold"
      style={{
        padding: sm ? '1px 7px' : '2px 8px',
        background: 'color-mix(in srgb, ' + meta.color + ' 14%, transparent)',
        color: meta.color,
        fontSize: sm ? 10 : 10.5,
      }}
    >
      <span
        style={{
          width: sm ? 5 : 6,
          height: sm ? 5 : 6,
          borderRadius: 999,
          background: meta.color,
        }}
      />
      {meta.label}
    </span>
  );
}
